import { Injectable } from '@angular/core';
import {
  Resolve,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';

import { catchError, map, mergeMap, switchMap, take } from 'rxjs/operators';
import { ParametersService } from '../parameters.service';
import { ConfigService } from '../../../_base/services/config.service';
import { AuditService } from '../../../_base/services/audit.service';
import { AppConst } from 'src/app/core/_base/const/app-const';
import { AuditModel } from 'src/app/core/_base/models/audit.model';

@Injectable({
  providedIn: 'root',
})
export class GeneralConfigResolverService implements Resolve<any> {
  constructor(
    private paramsService: ParametersService,
    private auditService: AuditService,
    private cs: ConfigService,
    private router: Router
  ) {}

  toBinary(string: any) {
    const codeUnits = new Uint16Array(string.length);
    for (let i = 0; i < codeUnits.length; i++) {
      codeUnits[i] = string.charCodeAt(i);
    }

    // Crear un nuevo Uint8Array para almacenar los bytes
    const bytes = new Uint8Array(codeUnits.length * 2);

    // Copiar los bytes de codeUnits al nuevo Uint8Array
    for (let i = 0; i < codeUnits.length; i++) {
      // Obtener el byte de orden inferior y el byte de orden superior
      const byte1 = codeUnits[i] & 0xff; // byte de orden inferior
      const byte2 = (codeUnits[i] >> 8) & 0xff; // byte de orden superior

      // Almacenar los bytes en el nuevo Uint8Array
      bytes[i * 2] = byte1; // Almacenar el byte de orden inferior
      bytes[i * 2 + 1] = byte2; // Almacenar el byte de orden superior
    }

    // Construir la cadena binaria
    let result = '';
    for (let i = 0; i < bytes.length; i++) {
      result += String.fromCharCode(bytes[i]);
    }
    return result;
  }


  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Observable<never> {
    return this.paramsService.GetParametersNew().pipe(
      switchMap(crisis => {
        if (crisis) {
          return this.auditService.star().pipe(
            map((auditModel: AuditModel) => {

              crisis.forEach(elemt => {
                const key = elemt.Parametro;
                const valueJSON = JSON.stringify(elemt.Valor);
                const JSONBinary = this.toBinary(valueJSON);
                const binaryEncrypt = btoa(JSONBinary);
                window.localStorage.setItem(key, binaryEncrypt);
              });

              return crisis;
            }),
            catchError(error => {
              console.error('Error al guardar los datos:', error);
              this.router.navigate(['/oops']);
              return EMPTY;
            })
          );
        } else {
          this.router.navigate(['/oops']);
          return EMPTY;
        }
      }),
      catchError(error => {
        console.error('Error al obtener parámetros:', error);
        this.router.navigate(['/oops']);
        return EMPTY;
      })
    );
  }
}
